import { Document } from '@roc/feature-types';
import { useDocumentStore } from '@roc/feature-documents';
import { Grid, Typography, Divider } from '@material-ui/core';
import { makeStyles, Theme } from '@material-ui/core/styles';
import { createStyles } from '@material-ui/core/styles';
import { BorrowerBaseballCardBaseStore } from 'libs/feature-borrowers/src/borrowers/stores/borrowerBaseballCardBaseStore';
import { observer } from 'mobx-react';
import PropertyInformationForm from './propertyInformationForm';
import { ADD_PROPERTY, EDIT_PROPERTY } from './utils';
import { isNil } from '@roc/feature-utils';
import PublicTrackRecordLineItem from './publicTrackRecordLineItem';
import { DialogState, StandardDialog, Button, FileUpload, FileUploadArea, FileUploadAreaWithDownload, createAutocompleteAddressField, createCurrencyField, createDateField, createRadioField, createSelectField, createTextField } from '@roc/ui';
import { stateOptions } from 'libs/client-portal-shared/src/app/modules/bridgePricer/utils/bridgePricerConstants';
import { dealTypeOptions } from 'libs/feature-borrowers/src/borrowerDetailsVerification/components/trackRecordVerification/subcomponents/trackRecordFirstStep/trackRecordPropertyForm';
import { BorrowerTrackRecordStore } from '@roc/feature-borrowers';
import { AddNewPropertyForm } from './addNewPropertyForm';
import { useEffect } from 'react';

export type PropertyInformationDialogProps = {
  loan?: any;
  store: BorrowerBaseballCardBaseStore;
  trackRecordStore: BorrowerTrackRecordStore;
  isVerified?: boolean;
  recordSourceType?: string;
  refreshData?: any;
};

const useStyles = makeStyles((theme: Theme) =>
  createStyles({
    typography: {
      marginTop: 0,
    },
    dialogContent: {
      padding: 0,
    },
    button: {
      marginRight: theme.spacing(1)
    }
  })
);

export const screenTypeOptions = [
  {
    label: 'Look up by Entity Name',
    value: 'entityName',
  },
  {
    label: 'Look up by Property Address',
    value: 'propertyAddress',
  },
];

export const NewPropertyInformationDialog = observer(
  (props: PropertyInformationDialogProps) => {
    const { store, trackRecordStore, recordSourceType, refreshData } = props;
    const classes = useStyles();
    const {
      propertyInformationDialogState,
      selectedVerifiedTrackRecordsId,
      selectedTrackRecordIsVerified,
      doPropertyLookup,
      selectedVerifiedTrackRecordsVerificationSource,
      selectedVerifiedTrackRecordsLinks
    } = store;
    const title =
      propertyInformationDialogState == DialogState.ADD
        ? ADD_PROPERTY
        : EDIT_PROPERTY;

    const formStore = store.propertyFormStore;

    return (
      <StandardDialog
        open={!isNil(propertyInformationDialogState)}
        maxWidth={doPropertyLookup ? 'xl' : 'md'}
        handleClose={() => { store.closePropertyInformationDialog(); trackRecordStore.borrowerTrackRecordVerificationStore.resetStore(); }}
        className={classes.dialogContent}
        dialogContent={
          <div className={classes.dialogContent}>
            <Grid item xs={12}>
              <Typography variant='h4'>{`Property Details`}</Typography>
            </Grid>
            {title === ADD_PROPERTY && (
              <Grid spacing={2} item xs={12} style={{ paddingTop: '8px' }}>
                {
                  createRadioField({
                    store: formStore,
                    testId: 'screenType',
                    fieldName: 'screenType',
                    label: "How would you like to add the property?",
                    options: screenTypeOptions,
                    row: true,
                  })
                }
              </Grid>
            )}
            {formStore.form.fields.screenType.value === 'propertyAddress' ? (
              <>
                <Grid>
                  <PropertyInformationForm
                    store={store}
                    verifiedTrackRecordsId={selectedVerifiedTrackRecordsId}
                    title={title}
                    disabled={selectedTrackRecordIsVerified}
                    isVerified={selectedTrackRecordIsVerified}
                    recordSourceType={recordSourceType}
                    links={selectedVerifiedTrackRecordsLinks}
                    verificationSource={selectedVerifiedTrackRecordsVerificationSource}
                    doPropertyLookup={doPropertyLookup}
                  />
                </Grid>
              </>
            ) : formStore.form.fields.screenType.value === 'entityName' ? (<>
                {<PublicTrackRecordLineItem store={store} isOpen={true} handleClose={() => { store.closePropertyInformationDialog(); trackRecordStore.borrowerTrackRecordVerificationStore.resetStore(); refreshData() }}/>}
              </>) : (<AddNewPropertyForm store={store} trackRecordStore={trackRecordStore} currentBorrower={store.currentBorrower}/>)}
          </div>
        }
      />
    );
  }
);

export default NewPropertyInformationDialog;
